import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {useNavigate} from "react-router-dom";

import appStore from "../../../storage/AppStore";
import clubStore from "../../../storage/ClubStore";

import Input from "../../../ui/Input";
import Select from "../../../ui/Select";
import Btn from "../../../ui/Btn";
import CheckBox from "../../../ui/CheckBox";

import MemberList from "../MemberList";
import PageLayout from "../../PageLayout";
import NumericPagination from "../../NumericPagination";


const Members = () => {
    const navigate = useNavigate();
    useEffect(() => {
        clubStore.getMembers();
    }, []);
    const search = () => {
        clubStore.memberQuery.setProperty(
            "page_number",
            1
        );

        clubStore.getMembers();
    };

    return (
        <PageLayout
            header={
                <div className="flex flex-column sm:flex-row gap-3 justify-content-between align-items-start sm:align-items-center w-full">
                    <div>
                        <div className="flex align-items-center gap-2">
                            <h2 className="m-0">
                                {appStore.tr.club_members}
                            </h2>
                            <span className="member-count-badge">
                                {clubStore.memberQuery.count || 0}
                            </span>
                        </div>
                        <div className="text-600 mt-1">
                            {appStore.tr.members_description || "Участники, родители и сотрудники клуба"}
                        </div>
                    </div>
                    <Btn
                        icon="pi pi-user-plus"
                        label={appStore.tr.add}
                        severity="success"
                        onClick={() =>
                            navigate(
                                "/manager/member/new"
                            )
                        }
                    />
                </div>
            }
            filters={
                <div className="member-filters">
                    <div className="grid">
                        {/* SEARCH */}
                        <div className="col-12 md:col-5">
                            <label className="block mb-1 text-sm text-600">
                                {appStore.tr.search}
                            </label>
                            <Input
                                store={
                                    clubStore.memberQuery
                                }
                                prop="name"
                                label={
                                    appStore.tr.search
                                }
                            />
                        </div>
                        {/* ROLE */}
                        <div className="col-12 sm:col-6 md:col-3">
                            <label className="block mb-1 text-sm text-600">
                                {appStore.tr.role}
                            </label>
                            <Select
                                store={
                                    clubStore.memberQuery
                                }
                                prop="role_id"
                                label={
                                    appStore.tr.role
                                }
                                options={
                                    appStore.rolesLocalized || []
                                }
                                optionLabel="name"
                                optionValue="id"
                                for_search
                                className="w-full"
                            />
                        </div>
                        {/* YEAR */}
                        <div className="col-6 sm:col-3 md:col-2">
                            <label className="block mb-1 text-sm text-600">
                                {appStore.tr.year_born}
                            </label>
                            <Input
                                store={
                                    clubStore.memberQuery
                                }
                                prop="year_born"
                                label={
                                    appStore.tr.year_born
                                }
                            />
                        </div>
                        {/* NUMBER */}
                        <div className="col-6 sm:col-3 md:col-2">
                            <label className="block mb-1 text-sm text-600">
                                {appStore.tr.forma_number}
                            </label>
                            <Input
                                store={
                                    clubStore.memberQuery
                                }
                                prop="forma_number"
                                label={
                                    appStore.tr.forma_number
                                }
                            />
                        </div>
                    </div>
                    <div className="flex flex-column sm:flex-row gap-3 justify-content-between align-items-start sm:align-items-center mt-2">
                        <CheckBox
                            label={appStore.tr.archive}
                            store={
                                clubStore.memberQuery
                            }
                            prop="include_archived"
                        />
                        <Btn
                            icon="pi pi-search"
                            label={appStore.tr.search}
                            severity="info"
                            className="w-full sm:w-auto justify-content-center"
                            onClick={search}
                        />
                    </div>
                </div>
            }
            pagination={
                <NumericPagination
                    query={
                        clubStore.memberQuery
                    }
                    onPageChange={(page) => {
                        clubStore.memberQuery.setProperty(
                            "page_number",
                            page
                        );

                        clubStore.fetchMembers(
                            false
                        );
                    }}
                />
            }

        >

            <MemberList
                members={
                    clubStore.members
                }
            />

        </PageLayout>
    );
};


export default observer(
    Members
);